import React, { FunctionComponent } from 'react';
import { SumInsuredContentsValueStep as CommonSumInsuredContentsValueStep } from 'scenes/common/components/Steps';

import { LandlordFullPageProps } from 'scenes/landlord/types';
import { getContentsSumInsured } from 'scenes/landlord/selectors';

const modalHelpText =
  'Includes items such as internal blinds and curtains (except where covered under building), fixtures and domestic structural improvements inside a strata title unit that are not insured by the body corporate, furniture and household goods that are not built-in, portable swimming pools and spas.';

const helpText =
  "Be sure to include everything in your total, including carpets, blinds, curtains, furniture,  electrical and household items provided for tenants' use.";

const SumInsuredContentsStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <CommonSumInsuredContentsValueStep
    onNext={onNext}
    defaultStateValue={getContentsSumInsured(funnelState)}
    valueRange={{ lowerLimit: '2000', upperLimit: '150000' }}
    modalHelpText={modalHelpText}
    helpText={helpText}
  />
);

export default SumInsuredContentsStep;
